import getEmbeddedManifest from '../utils/embedded-manifest';

export const key = 'wisepops';

export const integration = () =>
  getEmbeddedManifest({
    key,
    integrationConfig: {
      type: key,
      loadOnce: false,
      position: 'bodyEnd',
      name: 'wisepops',
      trackingId: {
        placeholder: 'wisepops.modal.placeholder',
        validator: (code) => {
          const regexTester = /^[\w]+$/;
          return regexTester.test(code);
        },
      },
    },
    dashboardWidget: {
      title: 'wisepops.widget.title',
      description: 'wisepops.widget.description',
    },
    detailsPage: {
      header: {
        title: 'wisepops.details-page.title',
        description: 'wisepops.details-page.subtitle',
        articleId: 'wisepops.details-page.articleId',
      },
      actions: {
        edit: {
          label: 'wisepops.details-page.cta.title.MI1.5',
        },
      },
      status: {},
    },
    modal: {
      type: 'flow',
      title: 'wisepops.modal.title',
      subtitle: 'wisepops.modal.subtitle',
    },
    requiredPermissions: ['my-account.manage-html-embeds'],
  });
